import { FoodsIcon } from "@foodpilot/foods";
import { Button, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type Props = {
    url: string | undefined | null;
    isLocked?: boolean | null;
    completion?: number | null;
};
export const GoToSsqButton = (props: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { url, isLocked = false, completion } = props;

    if (!url) {
        return null;
    }

    if (isLocked) {
        return (
            <Link to={url}>
                <Button variant={"primary"} endIcon={<FoodsIcon size={2} icon="arrowRight" />}>
                    {t("questionnaire.consult", "View")}
                </Button>
            </Link>
        );
    }

    const isComplete = completion === 100;
    const label = isComplete ? t("questionnaire.complete") : t("questionnaire.modify");
    return (
        <Link to={url}>
            <Button
                variant={"secondary"}
                endIcon={<FoodsIcon size={2} icon="arrowRight" />}
                sx={{ width: "100%", color: theme.custom.grey[2800] }}
            >
                <Typography variant="body-bold" sx={{ width: "100%" }}>
                    {label}
                </Typography>
            </Button>
        </Link>
    );
};
